/**
 * @generated SignedSource<<2462025a9527ccfc2f57e9c58705008b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteWebhookSubscriptionInput = {
  id: any;
};
export type PagerDutyIntegrationDeleteWebhookSubscriptionMutation$variables = {
  input: DeleteWebhookSubscriptionInput;
};
export type PagerDutyIntegrationDeleteWebhookSubscriptionMutation$data = {
  readonly deleteWebhookSubscription: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type PagerDutyIntegrationDeleteWebhookSubscriptionMutation = {
  response: PagerDutyIntegrationDeleteWebhookSubscriptionMutation$data;
  variables: PagerDutyIntegrationDeleteWebhookSubscriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteWebhookSubscriptionPayload",
    "kind": "LinkedField",
    "name": "deleteWebhookSubscription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PagerDutyIntegrationDeleteWebhookSubscriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PagerDutyIntegrationDeleteWebhookSubscriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eaab1bf4d0f7d83b0a106c419e5442e3",
    "id": null,
    "metadata": {},
    "name": "PagerDutyIntegrationDeleteWebhookSubscriptionMutation",
    "operationKind": "mutation",
    "text": "mutation PagerDutyIntegrationDeleteWebhookSubscriptionMutation(\n  $input: DeleteWebhookSubscriptionInput!\n) {\n  deleteWebhookSubscription(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c2edd92da6151d95d7cef3b8de70f27";

export default node;
